import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import BannerTemplates from './BannerTemplates';
import { showModal, hideModal } from '../../../../actions/modal';
import { getJioAdsLandingBannersFlag } from '../../../../refresh/selectors/featureFlagsSelector';
import { getAmplitudeVariantPayload } from '../../../../utils/amplitudeCommon';



function BannerComponentRenderer({
  slots,
  showModal,
  hideModal,
  isLuxe,
  jioAdsLandingBannersFlag,
  landingPagesExperiments,
  jioAdsLandingPagesExperiment
}) {
  return (
    <BannerTemplates
      slots={slots}
      showModal={showModal}
      hideModal={hideModal}
      isLuxe={isLuxe}
      jioAdsLandingBannersFlag={jioAdsLandingBannersFlag}
      landingPagesExperiments={landingPagesExperiments}
      jioAdsLandingPagesExperiment={jioAdsLandingPagesExperiment}
    />
  );
}

const mapStateToProps = state => {
  const store = state?.metaData?.name;
  const isLuxe = store === 'luxe';
  const landingPagesExperiments = getAmplitudeVariantPayload('landingPagesExperiments', state, state?.flags?.landingPagesExperiments || []);  
  const jioAdsLandingPagesExperiment = getAmplitudeVariantPayload('jioAdsLandingPagesExperiment', state, state?.flags?.jioAdsLandingPagesExperiment || '');     
  const jioAdsLandingBannersFlag = getJioAdsLandingBannersFlag(state) || false;
  return {
    slots: _get(state, 'banner.data.page.slots', []),
    isLuxe,
    jioAdsLandingBannersFlag,
    landingPagesExperiments,
    jioAdsLandingPagesExperiment
  };
};

const mapDispatchToProps = {
  showModal,
  hideModal
};
export default connect(mapStateToProps, mapDispatchToProps)(BannerComponentRenderer);
